<template lang="pug">
  div
    section.content-header
      h1 Sales Force Assistant 連携
      ol.breadcrumb
        li
          router-link(:to="{name: 'top'}")
            span.glyphicon.glyphicon-home
            | TOP
        li.active Sales Force Assistant 連携

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'top'}")
                button.btn.btn-default キャンセル

        +btnbar

        .callout.callout-info.bcard-callout
          h4 Sales Force Assistant  に名刺情報を連携します。
          p
            | 登録した名刺情報を Sales Force Assistant の パーソン情報にご利用いただけます。
            br
            | Sales Force Assistant 連携機能を使用する場合は、必要なログイン情報の設定を行ってください。

        //- 読み込み中はぐるぐる表示
        .panel.panel-default(v-if="isLoading")
          loading

        //- 読み込み中は表示しない
        .box.box-widget(v-if="!isLoading")

          .box-body
            .form-group
              label.control-label Sales Force Assistant 連携機能
              .radio.radio-rich
                label.radio-inline
                  input(type="radio" v-model="item.enable" :value="app_flag.OFF")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;使用しない
                label.radio-inline
                  input(type="radio" v-model="item.enable" :value="app_flag.ON")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;使用する

              .help-block
                p.bcard-comments.text-info
                  | ※ 使用する場合、次の機能に連携ボタンが表示されます。
                  br
                  | 連携ボタンをクリックすると、対象名刺を Sales Force Assistant に連携します。
                ul.bcard-comments.text-info
                  li 名刺詳細
                  li 名刺検索

            hr

            .form-group
              label.control-label 自動連携
              .radio.radio-rich
                label.radio-inline
                  input(type="radio" v-model="item.auto_send" :value="app_flag.OFF", :disabled="disableField")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;使用しない
                label.radio-inline
                  input(type="radio" v-model="item.auto_send" :value="app_flag.ON", :disabled="disableField")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;使用する

              .help-block
                p.bcard-comments.text-info
                  | ※ 使用する場合、次のタイミングで Sales Force Assistant に連携します。
                ul.bcard-comments.text-info
                  li 直接入力して登録
                  li 画像から登録（文字解析が完了した時点）
                  li ScanSnapから登録（文字解析が完了した時点）
                  li モバイルアプリから撮影して登録（文字解析が完了した時点）
            hr

            .form-group
              label.control-label(for="bcard-pvintegration-login-id") ログインID
                span.bcard-required(v-if="isIdPwRequired") (*)
              input#bcard-pvintegration-login-id.form-control(type="text" v-model="item.login_id", :maxlength="maxlengths.login_id", :required="isIdPwRequired", :disabled="disableField")

            .form-group
              label.control-label(for="bcard-pvintegration-login-pass") パスワード
                span.bcard-required(v-if="isIdPwRequired") (*)
              input#bcard-pvintegration-login-pass.form-control(type="password" v-model="item.login_pass", :maxlength="maxlengths.login_pass", :required="isIdPwRequired", :disabled="disableField")

            .help-block
              p.bcard-comments.text-info
                | ※ Sales Force Assistant の ログインID パスワードを設定してください。

            .bcard-btnbar
              button.btn.btn-info(type="button" @click="testLogin", :disabled="disableField") 接続確認
            app-messages(:errorMessages="loginErrors", :successMessages="loginSuccesses")

            .help-block(v-if="isIdPwRequired")
              p.bcard-required ※ (*)は必須項目です。

        +btnbar.-bottom

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'
import mixinForm from '@/mixins/form'

const NisfaIntegrationRepository = RepositoryFactory.get('pvnisfaintegration')

export default {
  name: 'PvNisfaIntegrationSettings',
  components: { AppMessages, Loading },
  mixins: [ mixinForm ],
  data: function () {
    return {
      isLoading: true, // 読み込み中かどうか
      maxlengths: {},

      item: {
        enable: '',
        login_id: '',
        login_pass: '',
        auto_send: ''
      },

      loginErrors: [],
      loginSuccesses: []
    }
  },
  computed: {
    disableField: function () {
      return this.item.enable === this.app_flag.OFF
    },
    isIdPwRequired () {
      return this.item.enable === this.app_flag.ON
    }
  },
  // 最初にこの機能に入ってきたときに実行される
  created: function () {
    const vm = this

    this.maxlengths = this.loadMaxlengths('PvNisfaIntegration')

    // API実行
    NisfaIntegrationRepository.get()
      .then(function (response) {
        const res = vm.getApiData(response).data
        // responseの入れ替え
        Object.keys(vm.item).forEach(itemKey => {
          vm.item[itemKey] = res[itemKey]
        })
        vm.isLoading = false
      })
      .catch(function (error) {
        // エラーコードが4013（契約なし）の場合、未契約ページを表示する
        const appCode = error.response ? vm.getAppErrCode(error.response.data.data.message) : ''
        if (appCode === '4013') {
          // APIからのエラーメッセージを流用したい場合はparamsに埋めることも可
          vm.$router.push({name: 'page-unlicensed'})
        }
        else {
          vm.setErrorMessage(error)
        }
      })
  },
  // データの保存期間設定共通メソッド
  methods: {
    // 送信処理
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this

      const sendData = {}

      Object.keys(vm.item).forEach(itemKey => {
        sendData[itemKey] = vm.item[itemKey]
      })

      // API実行
      NisfaIntegrationRepository.put(sendData)
        .then(function () {
          // 処理成功時はTOPに遷移する
          vm.$router.push({name: 'top'})
        }).catch(function (error) {
          // エラーメッセージを出す
          vm.setErrorMessage(error)
        })
    },
    testLogin () {
      this.loginErrors = []
      this.loginSuccesses = []

      if (this.item.login_id.length === 0 || this.item.login_pass.length === 0) {
        this.loginErrors.push('ログインIDとパスワードを入力してください。')
        return
      }

      // API実行
      const vm = this
      NisfaIntegrationRepository.login({
        nilogin: this.item.login_id,
        nipasswd: this.item.login_pass
      })
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.loginSuccesses.push('Sales Force Assistantへの接続に成功しました。')
          }
          else {
            const message = response.data.message || 'Sales Force Assistantへの接続確認に失敗しました。'
            vm.loginErrors.push(message)
          }
        }).catch(function (error) {
          const message = vm.getErrorMessage(error)
          vm.loginErrors.push(message)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/prsettings/PvNisfaIntegrationSettings.vue